import { Component, computed, EventEmitter, inject, input, output, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BuildingScanItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-building-scan-card',
  templateUrl: './building-scan-card.component.html',
  styleUrls: ['./building-scan-card.component.scss'],
})
export class BuildingScanCardComponent {

  readonly router = inject(Router);

  scan = input.required<BuildingScanItemDto>();

  canDelete = input.required<boolean>();

  canEdit = input.required<boolean>();

  readonly routerLink = computed(() => {
    const scan = this.scan();
    if (!scan) {
      return [];
    }
    if (scan.type === BuildingScanItemDto.TypeEnum.PointCloud) {
      return ['/pointCloudScan', scan.id];
    } else if (scan.type === BuildingScanItemDto.TypeEnum.Panorama) {
      return ['/scan', scan.id];
    }
    return [];
  });

  updated = output<BuildingScanItemDto>();

  deleteScan = output<BuildingScanItemDto>();

  editScan = output<BuildingScanItemDto>();
}
